/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportedTOTPCredentialParams
 */
export interface ExportedTOTPCredentialParams {
    /**
     * The total number of recovery codes originally issued to the given person.
     * @type {number}
     * @memberof ExportedTOTPCredentialParams
     */
    recovery_codes_total: number;
    /**
     * The total number of recovery codes still unused by the given person.
     * @type {number}
     * @memberof ExportedTOTPCredentialParams
     */
    recovery_codes_unused: number;
}

/**
 * Check if a given object implements the ExportedTOTPCredentialParams interface.
 */
export function instanceOfExportedTOTPCredentialParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recovery_codes_total" in value;
    isInstance = isInstance && "recovery_codes_unused" in value;

    return isInstance;
}

export function ExportedTOTPCredentialParamsFromJSON(json: any): ExportedTOTPCredentialParams {
    return ExportedTOTPCredentialParamsFromJSONTyped(json, false);
}

export function ExportedTOTPCredentialParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedTOTPCredentialParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recovery_codes_total': json['recovery_codes_total'],
        'recovery_codes_unused': json['recovery_codes_unused'],
    };
}

export function ExportedTOTPCredentialParamsToJSON(value?: ExportedTOTPCredentialParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recovery_codes_total': value.recovery_codes_total,
        'recovery_codes_unused': value.recovery_codes_unused,
    };
}

